import gql from "graphql-tag";
import { technicianQueryReturnFields } from "../queries/getTechnician";

export const UPDATE_TECHNICIAN = gql` mutation updateTechnician($id: ID!, $updateTechnicianInput: UpdateTechnicianInput!) {
    updateTechnician(id: $id, updateTechnicianInput: $updateTechnicianInput) {
        ${technicianQueryReturnFields}
    }
}`;
